module.exports = __webpack_public_path__ + "static/media/file.6fcdaf9b.svg";